import { FC, MouseEventHandler, ReactNode } from 'react';

/* Styles */
import styles from './Button.module.scss';

interface ButtonProps {
  className?: string;
  children: ReactNode;
  buttonType?: 'button' | 'reset' | 'submit';
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  ariaLabel?: string;
}

export const Button: FC<ButtonProps> = ({
  className = '',
  children,
  buttonType = 'button',
  disabled = false,
  onClick,
  ariaLabel = undefined,
}) => {
  return (
    <button
      className={`${styles.button} ${className}`}
      type={buttonType}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <span className={styles.text}>{children}</span>
    </button>
  );
};
